export default {"src":"/_next/static/media/filters.fac19520.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};